export default "__VITE_ASSET__ColwG5AE__"